/**
 * Kursbelegungen in der Schüleransicht.
 * Die aktive Belegung steht immer oben. Darunter die übrigen chronologisch,
 * die älteste ganz unten.
 */

function dayMs(value) {
  if (!value) return null;
  const parsed = Date.parse(String(value).slice(0, 10));
  return Number.isNaN(parsed) ? null : parsed;
}

function isActive(enrollment) {
  return enrollment?.status === 'active';
}

function compareBookings(a, b) {
  if (isActive(a) !== isActive(b)) return isActive(a) ? -1 : 1;
  const aEnd = dayMs(a.end_date);
  const bEnd = dayMs(b.end_date);
  if (aEnd !== bEnd) {
    if (aEnd == null) return -1;
    if (bEnd == null) return 1;
    return bEnd - aEnd;
  }
  return (dayMs(b.start_date) || 0) - (dayMs(a.start_date) || 0);
}

export function visibleCourseBookings(enrollments) {
  return [...(enrollments || [])].sort(compareBookings);
}
